import React,{useEffect,useState}from'react';
import * as FiIcons from'react-icons/fi';
import SafeIcon from'../common/SafeIcon';
import{
  deleteQuestionnaireTemplate,
  duplicateQuestionnaireTemplate,
  getQuestionnaireTemplates,
  updateQuestionnaireTemplate
}from'../utils/questionnaireTemplateStorage';
import QuestionnaireTemplateEditor from'./QuestionnaireTemplateEditor';
import'./settings-templates.css';
import'./questionnaire-templates.css';

const{FiCheck,FiCopy,FiEdit3,FiFileText,FiLayers,FiTrash2,FiX}=FiIcons;

function TemplatesPage(){
  const[questionnaireTemplates,setQuestionnaireTemplates]=useState([]);
  const[editingQuestionnaire,setEditingQuestionnaire]=useState(null);
  const[deleteCandidate,setDeleteCandidate]=useState(null);
  const[actionMessage,setActionMessage]=useState('');

  useEffect(()=>{
    setQuestionnaireTemplates(getQuestionnaireTemplates());
  },[]);

  const saveQuestionnaire=(sections)=>{
    const updated=updateQuestionnaireTemplate(editingQuestionnaire.id,sections);

    if(updated){
      setQuestionnaireTemplates((current)=>current.map((template)=>(
        template.id===updated.id?updated:template
      )));
      setActionMessage(`${updated.name} was saved.`);
    }

    setEditingQuestionnaire(null);
  };

  const duplicateQuestionnaire=(template)=>{
    const duplicate=duplicateQuestionnaireTemplate(template.id);

    if(duplicate){
      setQuestionnaireTemplates((current)=>[duplicate,...current]);
      setActionMessage(`${template.name} was duplicated.`);
    }
  };

  const requestDelete=(template)=>{
    setDeleteCandidate(template);
    setActionMessage('');
  };

  const cancelDelete=()=>{
    setDeleteCandidate(null);
  };

  const confirmDelete=()=>{
    if(!deleteCandidate)return;

    const deleted=deleteQuestionnaireTemplate(deleteCandidate.id);

    if(deleted){
      setQuestionnaireTemplates((current)=>(
        current.filter((template)=>(
          String(template.id)!==String(deleteCandidate.id)
        ))
      ));

      if(editingQuestionnaire?.id===deleteCandidate.id){
        setEditingQuestionnaire(null);
      }

      setActionMessage(`${deleteCandidate.name} was deleted.`);
    }else{
      setActionMessage('This template could not be deleted. Please try again.');
    }

    setDeleteCandidate(null);
  };

  return <main className="main-content templates-page">
    <div className="templates-page-heading">
      <div>
        <span className="eyebrow">Client experience</span>
        <h1>Questionnaire templates</h1>
        <p>Manage reusable client questionnaires for new events. Every change is saved locally on this device.</p>
      </div>
      <div className="templates-count">
        <strong>{questionnaireTemplates.length}</strong>
        <span>saved questionnaires</span>
      </div>
    </div>

    {actionMessage&&<div className="template-action-message" role="status">
      <SafeIcon icon={FiCheck}/>
      <span>{actionMessage}</span>
    </div>}

    {questionnaireTemplates.length===0?<section className="panel templates-empty">
      <div className="templates-empty-icon"><SafeIcon icon={FiFileText}/></div>
      <span className="eyebrow">Your library</span>
      <h2>No questionnaire templates saved</h2>
      <p>Create a questionnaire template to reuse the same client experience when creating future events.</p>
    </section>:<section className="questionnaire-template-grid" aria-label="Saved questionnaire templates">
      {questionnaireTemplates.map((template)=><article className="panel questionnaire-template-card" key={template.id}>
        <div className="template-card-top">
          <div className="template-icon"><SafeIcon icon={FiLayers}/></div>
          <div className="template-card-actions">
            <button
              type="button"
              className="icon-btn"
              onClick={()=>duplicateQuestionnaire(template)}
              aria-label={`Duplicate ${template.name} template`}
              title="Duplicate template"
            >
              <SafeIcon icon={FiCopy}/>
            </button>
            <button
              type="button"
              className="icon-btn"
              onClick={()=>setEditingQuestionnaire(template)}
              aria-label={`Edit ${template.name} template`}
              title="Edit template"
            >
              <SafeIcon icon={FiEdit3}/>
            </button>
            <button
              type="button"
              className="icon-btn danger"
              onClick={()=>requestDelete(template)}
              aria-label={`Delete ${template.name} template`}
              title="Delete template"
            >
              <SafeIcon icon={FiTrash2}/>
            </button>
          </div>
        </div>
        <h3>{template.name}</h3>
        <p>{template.description}</p>
        <div className="questionnaire-template-meta">
          <span><strong>{template.sections.length}</strong> sections</span>
          <span><strong>{template.sections.reduce((total,section)=>total+section.questions.length,0)}</strong> questions</span>
        </div>
        <div className="template-card-actions questionnaire-card-actions">
          <button type="button" className="button secondary" onClick={()=>setEditingQuestionnaire(template)}>
            <SafeIcon icon={FiEdit3}/> Edit questionnaire
          </button>
          <button type="button" className="button secondary" onClick={()=>duplicateQuestionnaire(template)}>
            <SafeIcon icon={FiCopy}/> Duplicate
          </button>
        </div>
      </article>)}
    </section>}

    {deleteCandidate&&<div className="modal-backdrop">
      <section className="modal-card template-delete-modal" role="dialog" aria-modal="true" aria-labelledby="delete-template-title">
        <div className="modal-heading">
          <div>
            <span className="eyebrow">Delete template</span>
            <h2 id="delete-template-title">Delete {deleteCandidate.name}?</h2>
          </div>
          <button type="button" className="icon-btn" onClick={cancelDelete} aria-label="Cancel deletion">
            <SafeIcon icon={FiX}/>
          </button>
        </div>
        <p className="template-delete-copy">
          This removes the questionnaire template from this device. Existing events and saved client answers are not changed.
        </p>
        <div className="modal-actions">
          <button type="button" className="button secondary" onClick={cancelDelete}>Cancel</button>
          <button type="button" className="button danger-button" onClick={confirmDelete}>
            <SafeIcon icon={FiTrash2}/> Delete template
          </button>
        </div>
      </section>
    </div>}

    {editingQuestionnaire&&<QuestionnaireTemplateEditor
      template={editingQuestionnaire}
      onClose={()=>setEditingQuestionnaire(null)}
      onSave={saveQuestionnaire}
    />}
  </main>;
}

export default TemplatesPage;